
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    DashboardCoreAppBar: () => import('../../components/core/AppBar.vue'),
    DashboardCoreDrawer: () => import('../../components/core/Drawer.vue'),
    DashboardCoreView: () => import('../../components/core/View.vue'),
  },
})
export default class DashboardIndex extends Vue {}
